import React from "react";
import { Switch } from "react-router-dom";
import { PrivateRoute } from "../../components/privateRoute";
import ListLexicons from './list-lexicons/list-lexions';
import EditLexicon from './edit-lexicon/edit-lexicon';
import AddLexicon from './edit-lexicon/add-lexicon';

const StratigraphyRoutes = () => {
  return (    
    <Switch>      
      <PrivateRoute exact path="/admin/stratigraphy/lexicon/list">
        <ListLexicons />        
      </PrivateRoute>      
      <PrivateRoute exact path="/admin/stratigraphy/lexicon/edit/:stratigraphyLexiconId">
        <EditLexicon />        
      </PrivateRoute>      
      <PrivateRoute exact path="/admin/stratigraphy/lexicon/add">
        <AddLexicon />        
      </PrivateRoute>      
    </Switch>            
  );
};

export default StratigraphyRoutes;
